<template>
  <div class="page">
    <!-- 搜索 -->
    <div class="searchBox">
      <el-form>
        <div v-show="activeIndex === '1'">
          <el-row>
            <el-col :span="3">
              <el-form-item>
                <span>预约日期</span>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item>
                <div
                  style="
                    width: 10px;
                    height: 10px;
                    background: #ea0000;
                    display: inline-block;
                    margin-right: 5px;
                    border-radius: 10px;
                  "
                ></div>
                <span>未确认</span>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item>
                <div
                  style="
                    width: 10px;
                    height: 10px;
                    background: skyblue;
                    display: inline-block;
                    margin-right: 5px;
                    border-radius: 10px;
                  "
                ></div>
                <span>未到店</span>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item>
                <div
                  style="
                    width: 10px;
                    height: 10px;
                    background: green;
                    display: inline-block;
                    margin-right: 5px;
                    border-radius: 10px;
                  "
                ></div>
                <span>已到店</span>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item>
                <div
                  style="
                    width: 10px;
                    height: 10px;
                    background: purple;
                    display: inline-block;
                    margin-right: 5px;
                    border-radius: 10px;
                  "
                ></div>
                <span>已取消</span>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item>
                <div
                  style="
                    width: 10px;
                    height: 10px;
                    background: #dbdbdb;
                    display: inline-block;
                    margin-right: 5px;
                    border-radius: 10px;
                  "
                ></div>
                <span>已锁定</span>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item>
                <div
                  style="
                    width: 10px;
                    height: 10px;
                    background: #999;
                    display: inline-block;
                    margin-right: 5px;
                    border-radius: 10px;
                  "
                ></div>
                <span>不可预约</span>
              </el-form-item>
            </el-col>
            <el-button
              type="warning"
              size="small"
              style="margin-top: 3px"
              @click="drawerAdd_state = true"
              >新建预约</el-button
            >
          </el-row>
          <el-row>
            <!--预约时间-->
            <div class="scroll-view scroll-view_H">
              <div class="list">
                <div>
                  <img
                    src="@/assets/img/left.png"
                    alt=""
                    class="imgNav"
                    @click="lastWeek"
                  />
                </div>

                <div
                  v-for="(item, index) in calendar"
                  :key="index"
                  @click="select(index)"
                  class="listItem"
                  :class="[index === currentIndex ? 'current' : '']"
                >
                  <el-badge
                    style="right: -2px"
                    :value="countList[index]"
                    class="item"
                    :key="index"
                  >
                    <div class="text name">{{ item.week }}{{ item.date }}</div>
                  </el-badge>
                </div>
                <div>
                  <img
                    src="@/assets/img/right.png"
                    alt=""
                    class="imgNav"
                    @click="nextWeek"
                  />
                </div>
              </div>
            </div>
          </el-row>
          <div style="height: 30px"></div>

          <div class="table_box">
            <table class="table">
              <tbody>
                <tr v-for="(itemA, index) in tableDataT" :key="index">
                  <td style="width: 130px; text-align: center">
                    {{ itemA.name }}
                  </td>
                  <td
                    v-for="(itemB, ix) in itemA.resvereDetailList"
                    :key="ix"
                    :colspan="itemB.merge"
                    :class="classS2(itemB.state)"
                  >
                    <!-- 解锁时间 -->
                    <el-popover
                      placement="right-start"
                      trigger="click"
                      v-show="itemB.state == 4"
                    >
                      <div class="box-card_lock">
                        <div @click="unLockResvereTime">
                          <img
                            src="@/assets/img/lock_unlock.png"
                            class="lockImg"
                            alt=""
                          />解锁时间
                        </div>
                      </div>
                      <div
                        slot="reference"
                        style="width: 100%; height: 100%"
                        @click="unlockTimer(itemA, itemB)"
                      ></div>
                    </el-popover>

                    <!-- 表头时间 -->
                    <div v-show="index == 0" style="text-align: center">
                      {{
                        itemB.time % 1 !== 0
                          ? parseInt(itemB.time) + ":30"
                          : itemB.time +
                            ":00" +
                            "-" +
                            parseInt(itemB.time + 1) +
                            ":00"
                      }}
                    </div>
                    <!-- 锁定时间 -->
                    <el-popover
                      placement="right-start"
                      trigger="click"
                      v-show="
                        !itemB.resvereChartRecord.length &&
                        index !== 0 &&
                        itemB.state == 1
                      "
                    >
                      <div class="box-card_lock">
                        <div @click="lockResvereTime">
                          <img
                            src="@/assets/img/lock.png"
                            class="lockImg"
                            alt=""
                          />
                          <span>锁定时间</span>
                        </div>
                      </div>
                      <div
                        slot="reference"
                        style="width: 100%; height: 100%"
                        @click="lockTimer(itemA, itemB)"
                      ></div>
                    </el-popover>

                    <!-- 预约 -->
                    <div
                      @click="see(itemC)"
                      v-show="itemB.resvereChartRecord.length"
                      v-for="(itemC, indexC) in itemB.resvereChartRecord.slice(
                        0,
                        1
                      )"
                      :key="indexC"
                    >
                      <span
                        style="display: inline-block; margin-bottom: 5px"
                        :class="classS1(itemC.resvereState)"
                      >
                        {{ itemC.userName }} <br />({{
                          itemC.userMobile
                        }})</span
                      >
                    </div>
                    <!-- 查看更多 -->
                    <span
                      style="color: #f5882a; font-size: 12px"
                      v-show="itemB.resvereChartRecord.length > 1"
                      @click="seeMoreUser(itemB.resvereChartRecord, itemB.time)"
                      >更多{{
                        itemB.resvereChartRecord.length - 1
                      }}个预约人员</span
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <el-drawer
            title="预约用户"
            :visible.sync="userState"
            :with-header="false"
          >
            <div class="showUser">
              <div style="font-weight: 600">预约用户</div>
              <div class="drawer_user">
                <div>预约类型:{{ reserveList[drawer_reserveType - 1] }}</div>
                <div>预约时间:{{ drawer_time + ":00" }}</div>
              </div>

              <div
                v-for="item in drawer_arr"
                :key="item.id"
                @click="see(item)"
                :class="classS1(item.resvereState)"
              >
                {{ item.userName }} <br />{{ item.userMobile }}
              </div>
            </div>
          </el-drawer>
        </div>
        <div v-show="activeIndex === '2'">
          <el-row>
            <el-col :span="3">
              <el-form-item>
                <el-input
                  style="width: 130px; margin-right: 10px"
                  placeholder="请输入内容"
                  v-model="search.keyword"
                  clearable
                  @keyup.enter.native="changeSearch"
                  size="small"
                ></el-input>
                <el-button @click="changeSearch" type="warning" size="small"
                  >搜索</el-button
                >
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="预约日期" :label-width="'90px'">
                <el-date-picker
                  size="small"
                  @change="changeSearch"
                  v-model="datetimerange"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  style="width: 220px"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="预约状态">
                <el-select
                  style="width: 100px"
                  class="select"
                  v-model="search.state"
                  @change="changeSearch"
                  placeholder="请选择"
                  size="small"
                >
                  <!-- 0 全部 1 未确认 2 未到店 3 已到店 -2 已取消 -->
                  <el-option
                    v-for="item in [
                      { label: '全部', value: 0 },
                      { label: '未确认', value: 1 },
                      { label: '未到店', value: 2 },
                      { label: '已到店', value: 3 },
                      { label: '已取消', value: -2 },
                    ]"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <resetBtn
                @reset="reset"
                style="width: 56px; display: inline-block; margin: 0px 10px"
              ></resetBtn>
            </el-col>
            <el-col :span="2">
              <el-button
                type="warning"
                size="small"
                style="margin-top: 3px"
                @click="drawerAdd_state = true"
                >新建</el-button
              >
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
    <div class="handBtns">
      <el-button
        size="small"
        style="margin-top: 3px"
        :class="[activeIndex == '1' ? 'active' : '']"
        @click="handleSelect('1')"
        >当前预约</el-button
      >
      <el-button
        size="small"
        style="margin-top: 3px"
        :class="[activeIndex == '2' ? 'active' : '']"
        @click="handleSelect('2')"
        >全部预约</el-button
      >
    </div>
    <div>
      <div class="pageConBox" v-show="activeIndex === '2'">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column label="预约日期">
            <template slot-scope="scope">
              {{ scope.row.reserveDate.split(" ")[0] }}
            </template>
          </el-table-column>
          <el-table-column label="预约类型">
            <template slot-scope="scope">
              <!-- // 1 洗美 2 医疗 3 寄养 4 看宠 -->
              {{ scope.row.reserveType == 1 ? "洗美" : "" }}
              {{ scope.row.reserveType == 2 ? "医疗" : "" }}
              {{ scope.row.reserveType == 3 ? "寄养" : "" }}
              {{ scope.row.reserveType == 4 ? "看宠" : "" }}
            </template>
          </el-table-column>
          <el-table-column label="预约时间">
            <template slot-scope="scope">
              {{ scope.row.reserveDate.split(" ")[1] }}
            </template>
          </el-table-column>
          <el-table-column label="预约客户" prop="linkmanName">
          </el-table-column>
          <el-table-column label="预约电话" prop="linkmanMobile">
          </el-table-column>
          <el-table-column label="预约备注" prop="remark"> </el-table-column>
          <el-table-column label="预约状态" prop="state">
            <template slot-scope="scope">
              <!-- 1 未确认 2 未到店 3 已到店 -2 已取消 0已删除 -->
              <div style="color: red">
                {{ scope.row.state == "1" ? "未确认" : "" }}
              </div>
              <div style="color: skyblue">
                {{ scope.row.state == "2" ? "未到店" : "" }}
              </div>
              <div style="color: purple">
                {{ scope.row.state == "3" ? "已到店" : "" }}
              </div>
              <div style="color: green">
                {{ scope.row.state == "-2" ? "已取消" : "" }}
              </div>
              <div style="color: pink">
                {{ scope.row.state == "0" ? "已删除" : "" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作时间">
            <template slot-scope="scope">
              {{ scope.row.createOperationInfo.operationTime }}
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                @click="see(scope.row)"
                type="text"
                size="small"
                v-if="scope.row.state == '3' || scope.row.state == '-2'"
                >查看</el-button
              >
              <el-button
                type="text"
                size="small"
                v-if="scope.row.state == '1'"
                @click="see(scope.row)"
                >确定预约</el-button
              >
              <el-button
                type="text"
                size="small"
                v-if="scope.row.state == '2'"
                @click="see(scope.row)"
                >到店</el-button
              >
              <el-button
                type="text"
                size="small"
                v-if="scope.row.state == '2' || scope.row.state == '1'"
                @click="getCancel(scope.row)"
                >取消</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="paging">
          <el-pagination
            background
            @current-change="changePage"
            :current-page="page.page"
            :page-size="page.pageSize"
            layout="total, prev, pager, next, jumper"
            :total="page.total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!--新增预约  -->
    <div v-if="drawerAdd_state">
      <drawerAdd @submit="submit_drawerAdd"></drawerAdd>
    </div>
    <!-- 查看洗美预约 -->
    <div v-if="drawerSeeBath_state">
      <drawerSeeT
        @submit="submit_drawerSeeBath"
        :arrivalState="arrivalState"
        :id="seeId"
      ></drawerSeeT>
    </div>
    <!--查看预约  -->
    <div v-if="drawerSee_state">
      <drawerSee
        @submit="submit_drawerSee"
        :id="seeId"
        :arrivalState="arrivalState"
      ></drawerSee>
    </div>
    <!--取消  -->
    <div v-if="drawerCancel">
      <drawerSeeCancel
        @submit="submit_drawerCancel"
        :id="seeId"
        :arrivalState="arrivalState"
      ></drawerSeeCancel>
    </div>
  </div>
</template>

<script>
import resetBtn from "../../../components/resetBtn.vue";
import drawerAdd from "./drawer_add.vue";
import drawerSee from "./drawer_see.vue";
import drawerSeeT from "./drawer_seeT.vue";
import drawerSeeCancel from "./drawer_seeCancel.vue";
// drawer_seeCancel
export default {
  components: {
    resetBtn,
    // 添加
    drawerAdd,
    drawerSee,
    // 非洗美
    drawerSeeT,
    drawerSeeCancel,
  },
  data() {
    return {
      day: "",
      lock_time: "",
      lock_staffid: "",
      lockState: false,
      unlockState: false,
      reserveList: ["洗美", "医疗", "寄养", "看宠"],
      // 查看预约 类型 时间
      drawer_reserveType: "",
      drawer_time: "",
      drawer_arr: "",
      userState: false,
      timerList: [],
      resvereChartRecord: [],
      drawerSeeBath_state: false,
      arrivalState: "",
      seeId: "",
      calendar: [],
      maxdays: 7,
      currentIndex: 0,
      currentTime: 0,
      timeArr: [],
      dateArr: [],
      cur_date: [],
      twoCalendar: [],
      num: 0,
      drawerAdd_state: false,
      drawerSee_state: false,
      drawerCancel: false,
      activeIndex: "1",
      search: {
        keyword: "",
        state: 0,
      },
      // 分页
      page: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      datetimerange: [], //预约时间
      value: new Date(),
      tableData: [],
      // 某一天的图表
      tableDataT: [],
      weekArr: [],
      countList: [],
      // 结束
      endTimer: "",
      // 开始
      startTimer: "",
    };
  },
  mounted() {
    this.weekArr = this.$DateTimeUtils.cycle(new Date());
    this.getWeekList(this.GetDateStr(this.num));
    this.getTableData();
    this.getDayResvereStatic();
    this.getWorkTimes();
    this.getResvereChart(this.calendar[0].date);
  },
  methods: {
    // 取消
    getCancel(a) {
      this.seeId = a.id;
      this.drawerCancel = true;
    },
    // 解锁
    unlockTimer(itemA, itemB) {
      this.lock_staffid = itemA.staffId;
      this.lock_time = itemB.time;
      this.unlockState = true;
    },
    // 解锁
    unLockResvereTime() {
      let params = {
        day: this.day,
        shopId: this.$store.state.shopId,
        staffId: this.lock_staffid,
        time: this.lock_time,
      };
      // console.log("params", params);
      let loading = this.$loading();
      this.$http
        .get(
          process.env.VUE_APP_AppAdmin + "/api/Resvere/UnLockResvereTime",
          params
        )
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            // console.log("res解锁", res);
            this.$message({
              message: res.data,
              type: "success",
            });
            this.getResvereChart(this.day);
            this.unlockState = false;
          }
        });
    },

    lockTimer(itemA, itemB) {
      // console.log("type", type);
      if (itemA.reserveType == 1) {
        this.lockState = true;
        this.lock_staffid = itemA.staffId;
        this.lock_time = itemB.time;
      }
    },
    // 锁定
    lockResvereTime() {
      let params = {
        day: this.day,
        shopId: this.$store.state.shopId,
        staffId: this.lock_staffid,
        time: this.lock_time,
      };
      // console.log("params", params);
      let loading = this.$loading();
      this.$http
        .get(
          process.env.VUE_APP_AppAdmin + "/api/Resvere/LockResvereTime",
          params
        )
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            // console.log("res锁定", res);
            this.$message({
              message: res.data,
              type: "success",
            });
            this.getResvereChart(this.day);
            this.lockState = false;
          }
        });
    },
    // 查看更多
    seeMoreUser(arr, time) {
      this.drawer_reserveType = arr[0].reserveType;
      this.drawer_time = time;
      this.drawer_arr = arr;
      this.userState = true;
    },
    // 动态添加css
    classS1(val) {
      let v = [];
      if (val == 1) {
        v.push("bg1");
      } else if (val == 2) {
        v.push("bg2");
      } else if (val == 3) {
        v.push("bg3");
      } else if (val == -2) {
        v.push("bg-2");
      } else {
        v.push("feedGray");
      }
      return v;
    },
    classS2(val) {
      let v = [];
      if (val == 3) {
        v.push("noYuyue");
      } else if (val == 4) {
        v.push("notYuyue");
      }
      return v;
    },
    // headerStyle方法：
    headerStyle({ row, columnIndex }) {
      row[3].colSpan = 2;
      row[4].colSpan = 0;
      if (columnIndex == 4 || columnIndex == 6) {
        return { display: "none" };
      }
      row[5].colSpan = 2;
      row[6].colSpan = 0;
    },

    // 获取班次信息
    getWorkTimes() {
      this.$http
        .get(process.env.VUE_APP_AppAdmin + "/api/ShopSchedule/shopWorkTimes", {
          shopId: this.$store.state.shopId,
        })
        .then((res) => {
          if (res.code == 0) {
            // this.workTimes = res.data.workTimes;
            this.startTimer = parseInt(
              res.data.workTimes[2].startTime.split(":")[0]
            );
            this.endTimer = parseInt(
              res.data.workTimes[2].endTime.split(":")[0]
            );
          }
        });
    },
    // 获取某一天的数据
    getResvereChart(data) {
      this.day = data;
      let params = {
        day: data,
        shopId: this.$store.state.shopId,
      };
      // console.log("params", params);
      this.$http
        .get(
          process.env.VUE_APP_AppAdmin + "/api/Resvere/GetResvereChart",
          params
        )
        .then((res) => {
          if (res.code == 0) {
            console.log("res", res);
            this.tableDataT = res.data;
          }
        });
    },
    // 获取一周的预约
    getDayResvereStatic() {
      this.countList = [];
      let params = {
        begin: this.calendar[0].date,
        end: this.calendar[6].date,
        shopId: this.$store.state.shopId,
      };
      var date =
        new Date(this.calendar[6].date).getTime() + 24 * 60 * 60 * 1000;
      params.end = this.$moment(date).format("YYYY-MM-DD");
      // console.log("params", params);
      this.$http
        .get(
          process.env.VUE_APP_AppAdmin + "/api/Resvere/GetDayResvereStatic",
          params
        )
        .then((res) => {
          if (res.code == 0) {
            // console.log("res", res);
            res.data.forEach((a) => {
              this.countList.push(a.count);
            });
            // console.log("countList", this.countList);
          }
        });
    },
    //
    seeCancel(a) {
      this.seeId = a.id;
      if (a.state == 2 && a.reserveType == 1) {
        this.arrivalState = "1";
        this.drawerSeeBath_state = true;
      }
      if (a.state == 2 && a.reserveType !== 1) {
        this.arrivalState = "1";
        this.drawerSee_state = true;
      }
    },
    // 取消
    submit_drawerCancel() {
      this.drawerCancel = false;
      this.getTableData();
    },
    // 洗美
    submit_drawerSeeBath() {
      this.drawerSeeBath_state = false;
      this.getTableData();
    },
    see(a) {
      this.userState = false;
      this.seeId = a.id;
      if (a.reserveType == 1) {
        //洗美
        this.drawerSeeBath_state = true;
      } else {
        // console.log("查看", a);
        this.drawerSee_state = true;
      }
    },
    // 获取列表数据
    getTableData() {
      let params = {
        pageIndex: this.page.page,
        pageSize: this.page.pageSize,
        keyword: this.search.keyword,
        shopId: this.$store.state.shopId,
        state: this.search.state,
      };
      if (this.datetimerange.length > 0) {
        params.beginTime = this.datetimerange[0] + " 00:00";
        params.endTime = this.datetimerange[1] + " 23:59";
      }
      let loading = this.$loading();
      // console.log("params", params);
      this.$http
        .post(
          process.env.VUE_APP_AppAdmin + "/api/Resvere/GetReserveRecordList",
          params
        )
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            // console.log("res列表数据", res);
            this.tableData = res.data.list;
            this.page.total = res.data.count;
          }
        });
    },
    // 点击下一周
    nextWeek() {
      this.num += 7;
      this.getWeekList(this.GetDateStr(this.num));
      this.getDayResvereStatic();
    },
    // 点击上一周
    lastWeek() {
      this.num -= 7;
      this.getWeekList(this.GetDateStr(this.num));
      this.getDayResvereStatic();
    },
    //
    GetDateStr(AddDayCount) {
      var dd = new Date();
      dd.setDate(dd.getDate() + AddDayCount); //获取AddDayCount天后的日期
      // console.log(dd)
      return dd;
    },
    getWeekList(date) {
      const that = this;
      const cur_year = date.getFullYear();
      const cur_month = date.getMonth() + 1;
      const cur_date = date.getDate();
      this.cur_date = cur_date;
      const weeks_ch = ["日", "一", "二", "三", "四", "五", "六"];
      //当前月份的天数
      let monthLength = that.getThisMonthDays(cur_year, cur_month);
      // 下个月
      // let next_date = 1;
      let next_month = date.getMonth() + 2;
      let next_year = date.getFullYear();
      if (next_month > 12) {
        next_month = 1;
        next_year = date.getFullYear() + 1;
      }
      //下个月份的天数
      let nextMonthLength = that.getThisMonthDays(next_year, next_month);
      //利用构造函数创建对象
      function calendar(date, week, cur_month, cur_year) {
        this.date = [cur_year, cur_month, date]
          .map(that.utils().formatNumber)
          .join("-");
        this.week = "周" + week;
      }
      //当前月份的第一天是星期几
      let week = that.getFirstDayOfWeek(cur_year, cur_month);
      let x = week;
      for (let i = 1; i <= monthLength; i++) {
        //当循环完一周后，初始化再次循环
        if (x > 6) {
          x = 0;
        }
        //利用构造函数创建对象
        that.twoCalendar[i] = new calendar(
          i,
          [weeks_ch[x]][0],
          cur_month,
          cur_year
        );
        x++;
      }
      let next_week = that.getFirstDayOfWeek(next_year, next_month);
      let next_x = next_week;
      for (let i = 1; i <= nextMonthLength; i++) {
        //当循环完一周后，初始化再次循环
        if (next_x > 6) {
          next_x = 0;
        }
        //利用构造函数创建对象
        that.twoCalendar[monthLength + i] = new calendar(
          i,
          [weeks_ch[next_x]][0],
          next_month,
          next_year
        );
        next_x++;
      }
      that.getCalenderByDay(that.maxdays, that.cur_date, that.twoCalendar);
    },
    // 获取当月天数
    getThisMonthDays(year, month) {
      return new Date(year, month, 0).getDate();
    },
    // 计算每月第一天是星期几
    getFirstDayOfWeek(year, month) {
      return new Date(Date.UTC(year, month - 1, 1)).getDay();
    },
    // 日期赋值(原)
    getCalenderByDay(maxDays, current_date, twoCalendar) {
      const that = this;
      //限制要渲染的日历数据天数为7天以内（用户体验）
      let flag = twoCalendar.slice(
        current_date,
        twoCalendar.length - current_date <= maxDays
          ? twoCalendar.length
          : current_date + maxDays
      );
      that.calendar = flag;
      //设置scroll-view的子容器的宽度
      that.width =
        186 *
        parseInt(
          twoCalendar.length - current_date <= maxDays
            ? twoCalendar.length
            : maxDays
        );
    },
    utils() {
      const formatTime = (date) => {
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const hour = date.getHours();
        const minute = date.getMinutes();
        const second = date.getSeconds();
        return (
          [year, month, day].map(formatNumber).join("/") +
          " " +
          [hour, minute, second].map(formatNumber).join(":")
        );
      };
      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();

        return [year, month, day].map(formatNumber).join("-");
      };
      const formatNumber = (n) => {
        n = n.toString();
        return n[1] ? n : "0" + n;
      };
      const dateDiff = (firstDate, secoundDate) => {
        // 如果 firstDate >= secoundDate 返回true 反之 false
        return new Date(firstDate) - new Date(secoundDate) >= 0;
      };
      return {
        formatTime,
        formatDate,
        formatNumber,
        dateDiff,
      };
    },
    select(index) {
      //为上半部分的点击事件
      this.currentIndex = index;
      console.log("index", index);
      // 获取某一天的
      this.getResvereChart(this.calendar[this.currentIndex].date);
    },

    add() {
      this.drawerAdd_state = true;
    },
    submit_drawerSee() {
      this.drawerSee_state = false;
      this.getTableData();
    },
    submit_drawerAdd() {
      this.drawerAdd_state = false;
      this.unlockState = false;
      this.lockState = false;
      this.getTableData();
    },
    changePage(num) {
      this.page.page = num;
      this.getTableData();
    },
    reset() {
      this.search.keyword = "";
      this.datetimerange = [];
      this.search.state = 0;
      this.getTableData();
    },
    changeSearch() {
      this.page.page = 1;
      this.getTableData();
    },
    //tab切换
    handleSelect(str) {
      console.log("str", str);
      if (str == 1) {
        this.getResvereChart(this.calendar[this.currentIndex].date);
      } else {
        this.getTableData();
      }
      if (this.activeIndex === str) return;
      this.activeIndex = str;
    },
  },
};
</script>
<style scoped lang="scss">
.box-card_lock {
  width: 100px;
  cursor: pointer;
  div {
    margin-bottom: 10px;
    display: flex;
    justify-content: center;
    align-content: center;
  }
  .lockImg {
    margin-right: 10px;
    width: 16px;
    height: 16px;
  }
}
.drawer_user {
  display: flex;
  justify-content: space-between;
}
.showUser {
  padding: 20px 40px;
  div {
    margin-bottom: 10px;
  }
}
.table_box {
  .table {
    width: 100%;
    height: 100%;
    text-align: center;
    font-size: 15px;
    background: #ffffff;
    border: 1px solid #cccccc;
    border-collapse: collapse;

    td {
      width: 50%;
      font-size: 12px;
      border-radius: 5px;
      box-sizing: border-box;
      height: 80px;
      white-space: nowrap;
      cursor: pointer;
      padding: 10px 20px;
      border: 1px solid #cccccc;
      text-align: left;
    }
  }
}
// 已锁定
.notYuyue {
  background: #dbdbdb;
}
// 不可预约
.noYuyue {
  background: #999;
}
.bg1 {
  height: 40px;
  /* line-height: 40px; */
  width: 90%;
  padding: 10px;
  border-left: 2px #ea0000 solid;
  background: #ffd4d4;
}
.bg2 {
  height: 40px;
  /* line-height: 40px; */
  border-left: 2px #0081ea solid;
  padding: 10px;
  background: #e0f1ff;
}
.bg3 {
  height: 40px;
  /* line-height: 40px; */
  border-left: 2px #11bb00 solid;
  padding: 10px;
  background: #dbffd7;
}
.bg-2 {
  height: 40px;
  border-left: 2px #6700ea solid;
  padding: 10px;
  background: #e9d8ff;
}
</style>
<style scoped lang="scss">
::v-deep .el-badge__content.is-fixed {
  right: -2px;
}
.page {
  .handBtns {
    position: absolute;
    right: 30px;
    top: 70px;
  }
}
.handBtns .active {
  background: #f5882a;
  color: aliceblue;
}
.scroll-view {
  background-color: #fff8f2;
  width: 100%;
  overflow: auto;
}
.imgNav {
  width: 30px;
  height: 30px;
  margin-top: 5px;
  cursor: pointer;
}
.scroll-view .list {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-items: center;
}

.scroll-view .listItem {
  padding: 10px;
  cursor: pointer;
  text-align: center;
  color: black;
  box-sizing: border-box;
  display: inline-block;
}

.scroll-view .listItem text {
  display: block;
}

.scroll-view .listItem .name {
  font-size: 12px;
}

.scroll-view .current {
  padding: 10px;
  color: #f5882a;
}

.time .listItem {
  width: 25%;
  height: 100px;
  text-align: center;
  box-sizing: border-box;
  background-color: #fff;
  padding-top: 18px;
  border: 1px solid #b9c1c8;
}

.time .listItem text {
  display: block;
  font-size: 21px;
}

.scroll-view .current .text {
  color: #f5882a;
}
</style>